import { 
  GET_IS_ACCEPT  ,     
  GET_IS_PO_ACCEPT ,   
  SET_IS_ACCEPT    ,   
  SET_IS_PO_ACCEPT   
  }  from "../actions/actionTypes";

  const initialState = {
      isAccept:false,
      isPoAccept:false,
   }

  function ApproveRedux(state = initialState, action) {
    switch (action.type) {
      case SET_IS_ACCEPT:
            return {
                ...state,
                isAccept: action.payload
            };
      case SET_IS_PO_ACCEPT:
            return {
                ...state,
                isPoAccept: action.payload
            };  
            case GET_IS_PO_ACCEPT:
              return {
                ...state,
                isPoAccept: action.payload
              };
              case GET_IS_ACCEPT:
                return {
                  ...state,
                  isPoAccept: action.payload
                };           
      default:
        return state
    }
  }
  
  export default ApproveRedux;